(function () {
  'use strict';

  /* @ngdoc object
   * @name widgets
   * @requires $stateProvider
   *
   * @description
   *
   */
  angular
    .module('widgets', [
      'ui.router',
      'ngPostMessage'
    ]);

  angular
    .module('widgets')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('widgetsAuthorise', {
        url: '/w/authorise?apiKey',
        templateUrl: 'widgets/authorise.tpl.html',
        controller: 'AuthoriseCtrl',
        controllerAs: 'vm',
        resolve: {
          userSession: ['Auth', function (Auth) {
            return Auth.getSession();
          }]
        }
      });
  }

})();
